<div class="sortable-th-container">
  <ng-content></ng-content>
  <fa-icon (click)="changeSortDirection()" class="sort-icon" [icon]="sortIcon" size="sm">
  </fa-icon>
</div>
